"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("extend"));
var TrackerUtil_1 = __importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = __importDefault(require("./BasicTrackerAbstractImpl"));
var LinkedInInsight = /** @class */ (function (_super) {
    __extends(LinkedInInsight, _super);
    function LinkedInInsight(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = LinkedInInsight.platformName;
        // Log information
        _this.getLogger().debug("LinkedInInsight instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     */
    LinkedInInsight.getInstance = function (options) {
        options = extend_1.default(true, {}, LinkedInInsight.defaultOptions, options);
        // Default the trackerName if not set.
        if (options.trackerName === undefined || options.trackerName === null) {
            var partnerIds = window[options.globalKeyForLinkedInDataPartnerIds];
            if (partnerIds !== undefined && partnerIds !== null && partnerIds.length > 0) {
                options.trackerName = partnerIds[0];
            }
        }
        // Get the instance
        var tracker = TrackerUtil_1.default.getInstance(options, LinkedInInsight.instances, function (options) {
            return new LinkedInInsight(options);
        }, function () {
            var partnerIds = window[options.globalKeyForLinkedInDataPartnerIds];
            return partnerIds !== undefined && partnerIds !== null && partnerIds.length > 0;
        });
        return tracker;
    };
    /**
     * Track a conversion. To get a conversion ID you must setup a conversion within LinkedIn's system.
     */
    LinkedInInsight.prototype.trackConversion = function (conversionId) {
        var _this = this;
        if (typeof conversionId !== "string") {
            conversionId = conversionId.toString();
        }
        var partnerId = this.getTrackerName();
        // Make request to LinkedIn to report the conversion
        var imgUrl = "https://px.ads.linkedin.com/collect/?pid=" + partnerId + "&conversionId=" + conversionId + "&fmt=gif";
        var img = new Image();
        img.onerror = function (err) {
            _this.getLogger().error("Failed to load image \"" + imgUrl + "\". Error:", err);
        };
        img.src = imgUrl;
        // Log
        this.getLogger().debug("LinkedInInsight.trackConversion:", "conversionId:", conversionId, "partnerId:", partnerId, "imgUrl for reporting:", imgUrl);
    };
    /**
     * This will return the partner ID for this instance of LinkedIn.
     */
    LinkedInInsight.prototype.getTrackerName = function () {
        return _super.prototype.getTrackerName.call(this);
    };
    LinkedInInsight.platformName = "LinkedInInsight";
    LinkedInInsight.instances = new Map();
    LinkedInInsight.defaultOptions = {
        globalKeyForPlatform: "lintrk",
        globalKeyForLinkedInDataPartnerIds: "_linkedin_data_partner_ids"
    };
    return LinkedInInsight;
}(BasicTrackerAbstractImpl_1.default));
exports.default = LinkedInInsight;
